import { initializeApp } from "firebase/app";
import {
  getFirestore,
  connectFirestoreEmulator,
  doc,
  collection,
  getDoc
} from "firebase/firestore";
import { getCookie, setCookie } from "@services/cookies";
import { get } from "lodash";

!(async () => {
  const useEmulator = JSON.parse(process.env.VUE_APP_FIREBASE_USE_EMULATOR);
  const $firebase = initializeApp({
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID
  });

  const $firestore = getFirestore($firebase);

  if (useEmulator) connectFirestoreEmulator($firestore, "localhost", 8082);

  const cookieKey = process.env.VUE_APP_AFFILIATE_COOKIE_NAME;
  const affCookie = getCookie(cookieKey);
  const urlParams = new URLSearchParams(window.location.search);
  const affLinkId = urlParams.get("id");
  let redirectUrl = "https://fixed.net";

  if (affLinkId) {
    const affLinkRef = doc(collection($firestore, "affLinks"), affLinkId);
    const affLinkDoc = await getDoc(affLinkRef);
    if (affLinkDoc.exists()) {
      redirectUrl = get(affLinkDoc.data(), "redirectUrl", redirectUrl);
      if (!affCookie) {
        const cookieValue = get(affLinkDoc.data(), "affAccountRef.id");
        const cookieMaxAge = 60 * 60 * 24 * 90; // 90 days
        setCookie(cookieKey, cookieValue, cookieMaxAge);
      }
    }
  }
  location.replace(redirectUrl);
})();
